export default "__VITE_ASSET__xt0FiP3q__"